import { isWidthUp } from '@material-ui/core/withWidth'

export default makeStyles((theme) => ({
  locationMarker: ({ width }) => ({
    backgroundColor: theme.palette.secondary.main,
    width: 130,
    height: 24,
    position: 'absolute',
    bottom: 13,
    left: -60,
    fontFamily: ['brother-1816', 'Arial', '"Helvetica Neue"'].join(','),
    fontSize: 13,
    textAlign: 'center',
    lineHeight: isWidthUp('md', width) ? '25px' : '24px',
    fontWeight: 600,
    color: 'white',
  }),
  locationDot: {
    position: 'absolute',
    top: -4,
    left: -4,
  },
  locationArrow: {
    position: 'absolute',
    bottom: 5,
    left: -2,
    width: 0,
    height: 0,
    borderLeft: '8px solid transparent',
    borderRight: '8px solid transparent',
    borderTop: `10px solid ${theme.palette.secondary.main}`,
  },
  storyMarker: {
    width: 50,
    height: 50,
    position: 'absolute',
    bottom: -25,
    left: -25,
  },
}))
